import { FormGroup } from "@mui/material";
import { DropdownFilter } from "../../../../../../components/dataGridFilter/filter-components/DropdownFilter";
import { SwitchFilter } from "../../../../../../components/dataGridFilter/filter-components/SwitchFilter";

export const FilterGroup3 = () => {
  const baseKey =
    "pages.inventoryManagement.inventory.list.filters.filterGroup3";

  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <SwitchFilter
        name="supplier.hasDiscount"
        labelKey={`${baseKey}.hasDiscount`}
      />
      <SwitchFilter
        name="supplier.deliveryDays"
        labelKey={`${baseKey}.deliveryDateUnknown`}
        operator="null"
      />
      <SwitchFilter
        name="productNameStartsWithBrandName"
        labelKey={`${baseKey}.productsWithSameBrand`}
      />
      <SwitchFilter
        name="marketplaceProduct.product.returnable"
        labelKey={`${baseKey}.nonReturnableProducts`}
        customValue={false}
      />
      <DropdownFilter
        name="supplier.hasPromoDiscount"
        labelKey={`${baseKey}.couponDiscount.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.couponDiscount.options.true` },
          { value: "false", label: `${baseKey}.couponDiscount.options.false` },
        ]}
      />
      <DropdownFilter
        name="supplier.primeExclusive"
        labelKey={`${baseKey}.primeDiscount.title`}
        operator="eq"
        hideLabelInChip
        options={[
          { value: "true", label: `${baseKey}.primeDiscount.options.true` },
          { value: "false", label: `${baseKey}.primeDiscount.options.false` },
        ]}
      />
    </FormGroup>
  );
};
